import Marquee from "react-fast-marquee";

const words = [
  "Professional Websites", "Digital Security", "Trusted IT Solutions",
  "Microsoft 365", "Google Workspace", "Website Hardening",
  "Domain Management", "Ongoing Support",
];

export default function BrandMarquee() {
  return (
    <div data-testid="brand-marquee" className="relative border-y border-white/10 bg-ink-soft/60 py-6">
      <Marquee gradient={false} speed={40} autoFill>
        {words.map((w, i) => (
          <div key={i} className="mx-8 flex items-center gap-8">
            <span className="font-heading text-lg font-medium tracking-tight text-white/70">{w}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
